/* te-bb2.js — VORSCHAU (UX-Runde 23.09.2026): Weiter-Knöpfe, Set-Preis je Karte, Bild antippbar,
   Auswahl-Leiste mit Miniaturen, dynamischer CTA, Warenkorb-Drawer mit angewandtem Code statt /cart.
   Basis: te-bb.js — TE-Bundle-Baukasten v2 „Outfit-Builder“ (Vorschau, 23.09.2026). Kein Framework.
   Größe normalisieren → Stufen/Reiter → Auswahl → Fortschritt/Ersparnis → Einmal-Code vom
   Server → /cart/add.js → Code an den Warenkorb (Fallback /discount/CODE). */
(function () {
  var root = document.querySelector('[data-te-bb]');
  if (!root) return;
  /* Start erst nach dem ersten Frame: der Baukasten-Init soll das erste Rendern (LCP) nicht aufhalten. */
  requestAnimationFrame(function () { setTimeout(init, 0); });
  function init() {
  var lang = root.dataset.lang === 'nl' ? 'nl' : 'de';
  var T = {
    de: { start: 'Stell dein Set zusammen – als Set sparst du {p} %.', need: 'Noch {n} {t} bis zum Set-Preis', part1: 'Teil', partN: 'Teile',
      done: 'Set komplett – du sparst {x}', add: 'Hinzufügen', added: '✓ Im Set', sizeFirst: 'Erst Größe wählen', wait: 'Einen Moment …',
      count: '{n} im Set anzeigen', remove: 'Entfernen', errNet: 'Der Set-Rabatt konnte gerade nicht erstellt werden.', errCart: 'Der Warenkorb hat nicht reagiert. Bitte erneut versuchen.',
      plain: 'Ohne Set-Rabatt in den Warenkorb', dropped: '{t} gibt es nicht in {s} – aus dem Set genommen.', max: 'Maximal {n} Teile pro Set.', chosen: '{n} gewählt', next: 'Weiter: {t}', ctaGo: 'In den Warenkorb · {x}', ctaGoShort: 'In den Warenkorb', saving: 'Du sparst {x}', savingSoon: 'Als Set sparst du {x}', ctaNeed: 'Noch {t}', ok: 'Set im Warenkorb ✓ – der Rabatt ist schon abgezogen.' },
    nl: { start: 'Stel je set samen – als set bespaar je {p} %.', need: 'Nog {n} {t} tot de setprijs', part1: 'item', partN: 'items',
      done: 'Set compleet – je bespaart {x}', add: 'Toevoegen', added: '✓ In set', sizeFirst: 'Kies eerst je maat', wait: 'Even geduld …',
      count: '{n} in set tonen', remove: 'Verwijderen', errNet: 'De setkorting kon nu niet worden aangemaakt.', errCart: 'De winkelwagen reageerde niet. Probeer het opnieuw.',
      plain: 'Zonder setkorting in winkelwagen', dropped: '{t} is er niet in {s} – uit de set gehaald.', max: 'Maximaal {n} items per set.', chosen: '{n} gekozen', next: 'Verder: {t}', ctaGo: 'In winkelwagen · {x}', ctaGoShort: 'In winkelwagen', saving: 'Je bespaart {x}', savingSoon: 'Als set bespaar je {x}', ctaNeed: 'Nog {t}', ok: 'Set in je winkelwagen ✓ – de korting is al verrekend.' }
  }[lang];
  var MAX = 12, PER = 12;
  var pct = parseInt(root.dataset.pct, 10) || 10;
  var sizeFirst = root.dataset.sizeFirst === 'true';
  var ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL', 'OS'];
  var ALIAS = { '2XL': 'XXL', 'XXXL': '3XL', 'XXXXL': '4XL', 'XXXXXL': '5XL' };
  var ONE = /^(EINHEITSGR(Ö|OE|O)SSE|ONE ?SIZE|ONESIZE|OS|UNI|UNISIZE|UNIVERSAL|(É|E)(É|E)N MAAT|ONE SIZE FITS ALL)$/;
  var size = null, sel = new Map(), busy = false, reached = {};
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  function f(s, o) { return s.replace(/\{(\w)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); }
  function kv(str) { var o = {}; (str || '').split(/[;,]/).forEach(function (p) { var i = p.indexOf(':'); if (i > 0) o[p.slice(0, i).trim()] = p.slice(i + 1).trim(); }); return o; }
  var groups = kv(root.dataset.groups), gnames = kv(root.dataset.groupNames);
  Object.keys(groups).forEach(function (g) { groups[g] = parseInt(groups[g], 10) || 0; });

  function one(tok) { tok = ALIAS[tok] || tok; return ONE.test(tok) ? 'OS' : (ORDER.indexOf(tok) > -1 ? tok : null); }
  function normSize(raw) {
    if (raw == null) return null;
    var s = String(raw).toUpperCase().replace(/\s+/g, ' ').trim();
    var w = one(s); if (w) return [w];
    var out = s.split(/\s*[\/|,]\s*|\s+-\s+/).map(one).filter(Boolean);
    return out.length ? out : null;
  }
  /* Geldformat aus der Marktwährung ableiten: Liquid rendert 123456 | money (z. B. „€1.234,56“
     oder „CHF 1,234.56“), daraus Präfix/Suffix und Trennzeichen. */
  var sample = root.dataset.moneySample || '€1.234,56';
  var mm = sample.match(/1(\D?)234(\D)56/) || [null, '.', ','];
  var mPre = sample.slice(0, sample.indexOf('1')), mSuf = sample.slice(sample.indexOf('56') + 2);
  function money(c) {
    var a = (Math.round(c) / 100).toFixed(2).split('.');
    return mPre + a[0].replace(/\B(?=(\d{3})+(?!\d))/g, mm[1]) + mm[2] + a[1] + mSuf;
  }

  /* ---------- Bereiche (Panels) und Stufen ---------- */
  var panels = $$('[data-te-bb-step]').map(function (el) {
    return { el: el, key: el.dataset.teBbStep, group: el.dataset.group || '', stage: el.dataset.stage, title: el.dataset.title,
      more: $('[data-te-bb-more]', el), empty: $('[data-te-bb-empty]', el), open: false, tabOff: false };
  });
  var stages = $$('[data-stage-el]').map(function (el) { return { el: el, id: el.dataset.stageEl, rec: parseInt(el.dataset.rec, 10) || 0 }; });

  /* ---------- Karten ---------- */
  var cards = $$('[data-te-bb-card]').map(makeCard);
  function makeCard(el) {
    var raw = []; try { raw = JSON.parse(el.dataset.v); } catch (e) {}
    var vars = raw.filter(Array.isArray).map(function (a) { return { id: a[0], price: a[1], opts: a[2] || [] }; });
    var si = parseInt(el.dataset.si, 10);
    if (si < 0 && vars.length && vars[0].opts.length) {
      for (var i = 0; i < vars[0].opts.length; i++) {
        if (vars.every(function (v) { return normSize(v.opts[i]); })) { si = i; break; }
      }
    }
    vars.forEach(function (v) {
      v.sizes = si >= 0 ? normSize(v.opts[si]) : null;
      v.label = v.opts.filter(function (o, i) { return i !== si && o !== 'Default Title'; }).join(' / ');
    });
    var sized = si >= 0 && vars.some(function (v) { return v.sizes && v.sizes.indexOf('OS') < 0; });
    var pel = el.closest('[data-te-bb-step]');
    var panel = panels.filter(function (p) { return p.el === pel; })[0];
    return { el: el, pid: el.dataset.pid, vars: vars, sized: sized, panel: panel,
      title: $('.te-bb__name', el).textContent.trim(), sel: $('[data-te-bb-var]', el),
      btn: $('[data-te-bb-add]', el), priceEl: $('[data-te-bb-price]', el), setEl: $('[data-te-bb-setprice]', el), media: $('[data-te-bb-pick]', el), cand: vars };
  }
  /* Nicht aktive Reiter liegen als <template> vor und kommen erst beim Öffnen ins DOM. */
  function materialize(p) {
    var tpl = $('template[data-te-bb-tpl]', p.el); if (!tpl) return;
    p.el.insertBefore(tpl.content, tpl); tpl.parentNode.removeChild(tpl);
    p.more = $('[data-te-bb-more]', p.el); bindMore(p);
    $$('[data-te-bb-card]', p.el).forEach(function (el) { var c = makeCard(el); cards.push(c); bindCard(c); });
  }

  /* ---------- Reiter ---------- */
  $$('.te-bb__tabs').forEach(function (bar) {
    var stageEl = bar.closest('[data-stage-el]');
    var ps = panels.filter(function (p) { return stageEl.contains(p.el); });
    var btns = $$('[data-tab]', bar);
    function show(key) {
      ps.forEach(function (p) { p.tabOff = p.key !== key; if (!p.tabOff) materialize(p); });
      btns.forEach(function (b) { b.setAttribute('aria-selected', b.dataset.tab === key ? 'true' : 'false'); });
      render();
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () { show(b.dataset.tab); });
      var p = ps.filter(function (x) { return x.key === b.dataset.tab; })[0];
      if (!p || p.el.dataset.n === '0') b.hidden = true;
    });
    var first = btns.filter(function (b) { return !b.hidden; })[0];
    if (first) { ps.forEach(function (p) { p.tabOff = p.key !== first.dataset.tab; }); first.setAttribute('aria-selected', 'true'); btns.forEach(function (b) { if (b !== first) b.setAttribute('aria-selected', 'false'); }); }
  });

  /* ---------- Größe ---------- */
  var sizeBox = $('[data-te-bb-sizes]');
  if (sizeBox) {
    var avail = {};
    cards.forEach(function (c) { if (c.sized) c.vars.forEach(function (v) { (v.sizes || []).forEach(function (s) { avail[s] = 1; }); }); });
    $$('[data-size]', sizeBox).forEach(function (b) {
      if (!avail[b.dataset.size]) b.disabled = true;
      b.addEventListener('click', function () { setSize(b.dataset.size); });
    });
    if (!cards.some(function (c) { return c.sized; })) { sizeBox.hidden = true; sizeFirst = false; }
  }
  function nextStage(fromEl) {
    var i = stages.map(function (s) { return s.el; }).indexOf(fromEl);
    var nx = stages[i + 1]; if (nx) setTimeout(function () { nx.el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 250);
  }
  function setSize(s) {
    size = s;
    $$('[data-size]', sizeBox).forEach(function (b) { b.setAttribute('aria-checked', b.dataset.size === s ? 'true' : 'false'); });
    var dropped = [];
    cards.forEach(function (c) {
      filterCard(c);
      var cur = sel.get(c.pid);
      if (cur && c.sized) {
        var still = c.cand.filter(function (v) { return v.id === cur.vid; })[0] || c.cand[0];
        if (still) { cur.vid = still.id; cur.price = still.price; cur.label = lab(c, still); } else { sel.delete(c.pid); dropped.push(c.title); }
      }
    });
    render();
    if (dropped.length) showErr(f(T.dropped, { t: dropped.join(', '), s: s }));
    /* 23.09.2026: kein automatisches Weiterscrollen mehr (Daniel) */
  }
  function lab(c, v) { return [c.sized && size ? size : '', v.label].filter(Boolean).join(' / '); }
  function fits(v) { return !v.sizes || v.sizes.indexOf(size) > -1 || v.sizes.indexOf('OS') > -1; }
  function filterCard(c) {
    c.cand = c.sized && size ? c.vars.filter(fits) : c.vars;
    c.hide = c.cand.length === 0;
    var s = c.sel, opts = c.cand;
    if (opts.length > 1 && !(c.sized && !size)) {
      s.innerHTML = '';
      opts.forEach(function (v) { var o = document.createElement('option'); o.value = v.id; o.textContent = v.label || (v.sizes || []).join('/') || '–'; s.appendChild(o); });
      var cur = sel.get(c.pid); if (cur) s.value = cur.vid;
      s.hidden = false;
    } else { s.hidden = true; }
    var v = opts.filter(function (x) { return x.id == s.value; })[0] || opts[0];
    if (v) { c.priceEl.textContent = money(v.price); if (c.setEl) c.setEl.textContent = money(v.price - Math.floor(v.price * pct / 100)); }
  }

  /* ---------- Auswahl ---------- */
  cards.forEach(bindCard);
  function bindCard(c) {
    filterCard(c);
    c.btn.addEventListener('click', function () {
      if (c.sized && sizeFirst && !size) { sizeBox.scrollIntoView({ behavior: 'smooth', block: 'center' }); sizeBox.classList.add('is-nudge'); setTimeout(function () { sizeBox.classList.remove('is-nudge'); }, 900); return; }
      if (sel.has(c.pid)) sel.delete(c.pid);
      else {
        if (sel.size >= MAX) { showErr(f(T.max, { n: MAX })); return; }
        var v = c.cand.filter(function (x) { return x.id == c.sel.value; })[0] || c.cand[0];
        if (!v) return;
        var im = c.el.querySelector('img');
        sel.set(c.pid, { vid: v.id, price: v.price, step: c.panel.key, group: c.panel.group, stage: c.panel.stage, title: c.title, label: lab(c, v), img: im ? (im.currentSrc || im.src) : '' });
      }
      showErr(''); render();
    });
    if (c.media) {
      c.media.addEventListener('click', function () { c.btn.click(); });
      c.media.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); c.btn.click(); } });
    }
    c.sel.addEventListener('change', function () {
      var v = c.cand.filter(function (x) { return x.id == c.sel.value; })[0]; if (!v) return;
      c.priceEl.textContent = money(v.price); if (c.setEl) c.setEl.textContent = money(v.price - Math.floor(v.price * pct / 100));
      var cur = sel.get(c.pid); if (cur) { cur.vid = v.id; cur.price = v.price; cur.label = lab(c, v); render(); }
    });
  }
  /* Weiter-Knöpfe statt automatischem Scrollen: der Kunde entscheidet, wann er weitergeht. */
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  stages.forEach(function (st, i) {
    var nx = stages[i + 1]; if (!nx) return;
    var t = (nx.el.querySelector('.te-bb__stage-title') || {}).textContent || '';
    var b = document.createElement('button'); b.type = 'button'; b.className = 'button self-button button--secondary te-bb2__next'; b.hidden = true;
    b.textContent = f(T.next, { t: t.trim() }) + ' ↓';
    b.addEventListener('click', function () { nx.el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); });
    st.el.appendChild(b); st.next = b;
  });
  function bindMore(p) { if (p.more) p.more.addEventListener('click', function () { p.open = true; render(); }); }
  panels.forEach(bindMore);
  function stageCount(id) { var n = 0; sel.forEach(function (x) { if (x.stage === id) n++; }); return n; }

  var bar = $('[data-te-bb-bar]'), msg = $('[data-te-bb-msg]'), fill = $('[data-te-bb-fill]'), orig = $('[data-te-bb-orig]'),
    tot = $('[data-te-bb-total]'), save = $('[data-te-bb-save]'), saving = $('[data-te-bb-saving]'), cta = $('[data-te-bb-cta]'), tray = $('[data-te-bb-tray]'),
    okMsg = $('[data-te-bb-ok]'), err = $('[data-te-bb-err]');

  function status() {
    var need = 0, what = [], req = 0;
    Object.keys(groups).forEach(function (g) {
      var n = 0; sel.forEach(function (x) { if (x.group === g) n++; });
      req += groups[g];
      if (n < groups[g]) { var miss = groups[g] - n; need += miss; var nm = (gnames[g] || '').split('|'); what.push(miss + ' ' + (miss === 1 ? nm[0] : (nm[1] || nm[0])) ); }
    });
    req = Math.max(req, 2);
    if (sel.size + need < 2) { what = []; need = 2 - sel.size; }
    return { need: need, what: what, req: req, done: need === 0 };
  }
  function render() {
    var s = status(), sum = 0, disc = 0;
    sel.forEach(function (x) { sum += x.price; disc += Math.floor(x.price * pct / 100); /* Shopify rundet je Zeile ab */ });
    cards.forEach(function (c) {
      var on = sel.has(c.pid), lock = c.sized && sizeFirst && !size;
      c.el.classList.toggle('is-on', on); c.el.classList.toggle('is-lock', lock);
      c.btn.classList.toggle('button--primary', on); c.btn.classList.toggle('button--secondary', !on);
      c.btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      c.btn.textContent = on ? T.added : (lock ? T.sizeFirst : T.add);
    });
    panels.forEach(function (p) {
      var vis = 0, hidden = 0, all = 0;
      cards.forEach(function (c) {
        if (c.panel !== p) return;
        all++;
        var h = !!c.hide;
        if (!h) { vis++; if (!p.open && vis > PER && !sel.has(c.pid)) { h = true; hidden++; } }
        c.el.hidden = h;
      });
      p.el.hidden = p.tabOff;
      if (p.more) p.more.hidden = hidden === 0;
      p.empty.hidden = vis > 0 || all === 0;
      var n = 0; sel.forEach(function (x) { if (x.step === p.key) n++; });
      var tb = p.el.closest('[data-stage-el]').querySelector('[data-tab="' + p.key + '"] [data-tab-n]');
      if (tb) tb.textContent = n ? ' · ' + n : '';
    });
    stages.forEach(function (st) {
      var n = st.id === 'size' ? (size ? 1 : 0) : stageCount(st.id);
      var ok = st.id === 'size' ? !!size : (st.rec ? n >= st.rec : n > 0);
      st.el.classList.toggle('is-done', ok);
      if (st.next) st.next.hidden = !(ok || (!st.rec && st.id !== 'size'));
      var pill = $('[data-te-bb-status]', st.el); if (pill && n && st.id !== 'size') pill.textContent = f(T.chosen, { n: n });
      var nav = $('[data-nav="' + st.id + '"]'); if (nav) nav.parentNode.classList.toggle('is-done', ok);
    });
    fill.style.width = Math.min(100, Math.round((s.req - s.need) / s.req * 100)) + '%';
    bar.classList.toggle('is-done', s.done); bar.classList.toggle('is-active', sel.size > 0);
    if (!sel.size) msg.textContent = f(T.start, { p: pct });
    else if (!s.done) msg.textContent = s.what.length ? f(T.need, { n: '', t: s.what.join(' + ') }).replace('  ', ' ') : f(T.need, { n: s.need, t: s.need === 1 ? T.part1 : T.partN });
    else msg.textContent = (window.innerWidth < 750 ? (lang === 'nl' ? '✓ Set compleet' : '✓ Set komplett') : T.done).replace('{x}', money(disc));
    /* disc = Summe der je Stück abgerundeten 10 % — identisch mit dem Abzug im Checkout (geprüft mit 2/3/5 Teilen, Mengen 2 und 3). */
    if (s.done) { orig.textContent = money(sum); tot.textContent = money(sum - disc); save.hidden = false; save.textContent = '−' + pct + ' %'; }
    else { orig.textContent = ''; tot.textContent = money(sum); save.hidden = true; }
    saving.hidden = !sel.size; saving.classList.toggle('is-live', s.done);
    saving.textContent = f(s.done ? T.saving : T.savingSoon, { x: money(disc) });
    cta.disabled = !s.done || busy;
    if (!busy) cta.textContent = s.done ? (window.innerWidth < 750 ? T.ctaGoShort : f(T.ctaGo, { x: money(sum - disc) }))
      : (sel.size ? f(T.ctaNeed, { t: s.what.length ? s.what.join(' + ') : s.need + ' ' + (s.need === 1 ? T.part1 : T.partN) }) : ctaTxt);
    if (sel.size) okMsg.hidden = true;
    tray.hidden = !sel.size;
    tray.innerHTML = '';
    sel.forEach(function (x, pid) {
      var li = document.createElement('li'), b = document.createElement('button');
      li.className = 'te-bb2__thumb'; li.title = x.title + (x.label ? ' · ' + x.label : '');
      if (x.img) { var im = document.createElement('img'); im.src = x.img; im.alt = ''; im.width = 48; im.height = 48; li.appendChild(im); }
      else { li.textContent = x.title.slice(0, 2); }
      b.type = 'button'; b.textContent = '×'; b.setAttribute('aria-label', T.remove + ': ' + x.title);
      b.addEventListener('click', function () { sel.delete(pid); render(); });
      li.appendChild(b); tray.appendChild(li);
    });
  }
  function showErr(t, plainBtn) {
    err.textContent = t; err.hidden = !t;
    if (plainBtn) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'button self-button button--secondary te-bb__plain'; b.textContent = T.plain;
      b.addEventListener('click', function () { addToCart(null); }); err.appendChild(document.createTextNode(' ')); err.appendChild(b);
    }
  }

  /* ---------- Warenkorb ---------- */
  var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function addToCart(code) {
    var items = [];
    sel.forEach(function (x) {
      var p = { '_te_bb': root.dataset.bundle, 'Set': root.dataset.name };
      if (code) p._te_bb_code = code;
      items.push({ id: x.vid, quantity: 1, properties: p });
    });
    return fetch(cartRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); })
      .then(function () {
        if (!code) { location.href = cartRoot + 'cart'; return; }
        var fallback = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartRoot + 'cart');
        /* Empfehlung Punkt 13: Code anwenden und den Warenkorb-Drawer der Seite öffnen (Kunde bleibt
           im Kontext, sieht Rabatt + Kasse). Die Sections des Drawers kommen in derselben Antwort mit;
           fehlt der Drawer oder schlägt etwas fehl, geht es wie bisher auf /cart bzw. /discount/. */
        var drawer = document.querySelector('cart-drawer');
        var secs = [];
        try { document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: secs } })); } catch (e) {}
        return fetch(cartRoot + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code, sections: secs, sections_url: location.pathname }) })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            var ok = (c.discount_codes || []).some(function (d) { return d.code === code && d.applicable; });
            if (!ok) { location.href = fallback; return; }
            if (!drawer || !window.theme || !theme.pubsub || !c.sections || !secs.length) { location.href = cartRoot + 'cart'; return; }
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'te-bb', cart: c });
            if (drawer.show) drawer.show(cta);
            sel.clear(); busy = false; render();
            okMsg.textContent = T.ok; okMsg.hidden = false;
          })
          .catch(function () { location.href = fallback; });
      })
      .catch(function () { busy = false; cta.textContent = ctaTxt; render(); showErr(T.errCart); });
  }
  var ctaTxt = cta.textContent;
  cta.addEventListener('click', function () {
    if (busy || !status().done) return;
    busy = true; cta.disabled = true; cta.textContent = T.wait; showErr('');
    var items = []; sel.forEach(function (x) { items.push({ v: x.vid, s: x.step }); });
    fetch(root.dataset.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ bundle: root.dataset.bundle, items: items, lang: lang }) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok || !j.code) throw new Error(j.detail || j.error || T.errNet); return j; }); })
      .then(function (j) { return addToCart(j.code); })
      .catch(function (e) { busy = false; cta.textContent = ctaTxt; render(); showErr(e && e.message && e.message.length < 160 ? e.message : T.errNet, true); });
  });

  render();
  }
})();
